import { EnvelopeIcon } from '@/app/icons/EnvelopeIcon';
import { SuccessMessageContent } from '@/components/common/SuccessMessageContent';
import React, { FC } from 'react';

export const EmailSuccess: FC = () => {
  return (
    <SuccessMessageContent
      icon={<EnvelopeIcon sx={{ width: '56px', height: '56px' }} />}
      title={'Подтвердите адрес электронной почты'}
      description={
        'Мы отправили вам письмо со ссылкой для верификации на старый электронный адрес. Перейдите по ссылке, чтобы подтвердить свой новый адрес электронной почты.'
      }
    />
  );
};
